<template>
  <div>
    <div class="upload-image-box" :class="{ disabled: disabled }">
      <v-checkbox v-if="required" v-model="showImage" class="d-none" :rules="[$utils.validators.required]"></v-checkbox>
      
      <div v-if="showImage" class="center-right" style="height: 100px">
        <div style="height: 100%; width: 50%">
          <div class="top-right" style="height: 50%">
            <span class="medium-emp button-medium mt-1" v-html="title"></span>
          </div>
          <div class="bottom-right" style="height: 50%; width: 100%">
            <v-btn
              v-if="editable === true"
              text
              color="var(--logisitic)"
              class="button-medium ml-auto px-2"
              style="font-size: 15px"
              :disabled="disabled"
              :loading="isUploading"
              @click.prevent="editImage"
            >
              <v-icon size="14" class="">mdi-pencil</v-icon>
              ویرایش
            </v-btn>

            <v-btn
              v-if="deletable === true"
              text
              color="#B00020"
              class="button-medium ml-auto px-2"
              style="font-size: 15px"
              :disabled="disabled"
              @click.prevent="deleteUploadedImage"
              max-width="10%"
            >
              <svg-icon
                name="delete-fill"
                :color="disabled ? 'rgba(0, 0, 0, 0.2)' : '#B00020'"
                width="14"
                height="14"
              ></svg-icon>
              حذف
            </v-btn>
          </div>
        </div>
        <div class="mr-auto center-left" style="height: 100px; width: 50%">
          <img
            v-if="uploadedImageUrl || defaultImageUrl"
            :src="uploadedImageUrl ? uploadedImageUrl : defaultImageUrl"
            :alt="title"
            draggable="false"
            class="image"
          />
        </div>
      </div>

      <div v-else>
        <div class="center-right">
          <div class="center-right">
            <v-icon class="mb-1 ml-2">mdi-cloud-upload</v-icon>
            <span class="medium-emp button-medium" v-html="title"></span>
          </div>
          <div class="mr-auto">
            <v-btn
              text
              color="var(--logistic)"
              class="button-medium px-1 px-md-3"
              :disabled="disabled"
              @click.prevent="uploadImage"
            >
              <v-icon size="20" class="ml-1">mdi-plus</v-icon>
              انتخاب تصویر
            </v-btn>
          </div>
        </div>

        <div v-if="isUploading" class="center-right mt-2">
          <v-icon class="ml-2" @click.prevent="cancelUploading">
            mdi-close-circle-outline
          </v-icon>

          <v-progress-linear
            rounded
            reverse
            indeterminate
            height="3"
            color="#1565C0"
          ></v-progress-linear>
        </div>
      </div>

      <image-uploader
        ref="imageUploader"
        :debug="0"
        :maxWidth="1024"
        :quality="0.8"
        :autoRotate="false"
        :preview="false"
        :capture="false"
        outputFormat="blob"
        accept="image/jpg, image/jpeg, image/heic, image/png"
        style="display: none"
        @onUpload="startUploadImage"
        @onComplete="completeUploadImage"
        v-model="uploadedImageBlob"
      >
      </image-uploader>
    </div>

    <div v-if="!showImage && showAlert" class="center-right mt-2">
      <v-icon size="14" class="mx-2">mdi-alert</v-icon>
      <span class="caption-regular" style="color: rgba(0, 0, 0, 0.6)">
        تصویر واضحی از {{ title }} بارگذاری کنید.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadImage",
  emits: ["set-image", "delete-image"],
  props: {
    title: {
      type: String,
      default: "",
      required: false,
    },
    editable: {
      type: Boolean,
      default: false,
      required: false,
    },
    deletable: {
      type: Boolean,
      default: false,
      required: false,
    },
    showAlert: {
      type: Boolean,
      default: false,
      required: false,
    },
    defaultImage: String,
    disabled: Boolean,
    required: Boolean
  },
  data() {
    return {
      showImage: false,
      isUploadingCanceled: false,
      defaultImageUrl: "",

      uploadedImageBlob: null,
      uploadedImageUrl: "",
      uploadedImageFile: null,

      isUploaded: false,
      isUploading: false,
    };
  },
  methods: {
    uploadImage() {
      if (this.disabled) return;

      const imageUploaderElement = this.$refs.imageUploader.$el.lastChild;
      if (!imageUploaderElement) return;

      imageUploaderElement.click();
    },

    cancelUploading() {
      this.isUploadingCanceled = true;
    },

    editImage() {
      if (!this.disabled) this.uploadImage();
    },

    deleteUploadedImage() {
      if (this.disabled) return;

      this.$emit("delete-image");

      this.showImage = false;

      this.uploadedImageBlob = null;
      this.uploadedImageUrl = "";
      this.isUploaded = false;
      this.isUploading = false;
    },

    startUploadImage() {
      this.isUploading = true;
      this.isUploaded = false;
    },

    completeUploadImage() {
      this.isUploading = false;
      this.isUploaded = true;

      if (this.isUploadingCanceled === false) this.setUploadedImage();
      this.isUploadingCanceled = false;
    },

    setUploadedImage() {
      const successfulUpload = this.isUploaded && !!this.uploadedImageBlob;

      if (successfulUpload) {
        this.setImageUrl();
        this.checkIfImageReadyToShow();
        this.emitImageData();
      }
    },

    setImageUrl() {
      this.uploadedImageUrl = URL.createObjectURL(this.uploadedImageBlob);
    },

    checkIfImageReadyToShow() {
      if (this.uploadedImageUrl) this.showImage = true;
    },

    emitImageData() {
      if (!this.uploadedImageUrl) return;

      const imageData = {
        blob: this.uploadedImageBlob,
        url: this.uploadedImageUrl,
      };
      this.$emit("set-image", imageData);
    },

    setDefaultImage() {
      this.defaultImageUrl = this.defaultImage;
      this.showImage = true;
    },
  },
  watch: {
    defaultImage: {
      handler(defaultImage) {
        if (defaultImage) this.setDefaultImage();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.upload-image-box {
  width: 100%;
  height: auto;
  background-color: #ffffff;
  border: 1px dashed rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 12px 8px;
}
.upload-image-box.disabled {
  opacity: 0.5;
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.center-right {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.center-left {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.top-right {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.bottom-right {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}
.image {
  max-width: 100%;
  max-height: 100%;
  box-shadow: 0 0 0 1px rgba(21, 101, 192, 0.25);
  border-radius: 8px;
}
</style>
